// @flow
import React, { useState } from 'react';
import moment from 'moment';
import Subheader from 'material-ui/Subheader';
import { formatSpellCheckResult } from '../../util/spell-check';
import ArticleFactCheckingDialog from './ArticleFactCheckingDialog';

export type SpellCheckStatusProp = ?{
	id?: ?string,
	checkId: string,
	userId?: ?string,
	startedAt: string,
	response?: ?string,
	passed: boolean,
	error?: ?string,
	user?: ?{ id: string, name?: ?string },
};

export type SpellCheckResultProp = ?{
	rawAnswer: string,
	factChecking: ?string,
};

type Props = {
	status: SpellCheckStatusProp,
	spellCheckLoading: boolean,
	spellCheckResult: SpellCheckResultProp,
};

const wrapLongText = {
	whiteSpace: 'pre-wrap',
	overflowWrap: 'anywhere',
	wordBreak: 'break-word',
	maxWidth: '100%',
};

const factCheckingLinkStyle = {
	display: 'inline-block',
	marginTop: 16,
	color: '#542376',
	cursor: 'pointer',
	textDecoration: 'underline',
	fontSize: 14,
	whiteSpace: 'nowrap',
	border: 'none',
	background: 'none',
	padding: 0,
};

export default function ArticleSpellCheckStatusSection({
	status: st,
	spellCheckLoading,
	spellCheckResult,
}: Props) {
	const [factCheckingOpen, setFactCheckingOpen] = useState(false);

	const responseRaw =
		spellCheckResult != null && spellCheckResult.rawAnswer !== ''
			? spellCheckResult.rawAnswer
			: st != null && st.response != null && st.response !== ''
				? st.response
				: null;

	const factChecking =
		spellCheckResult != null &&
		spellCheckResult.factChecking != null &&
		spellCheckResult.factChecking.trim() !== ''
			? spellCheckResult.factChecking
			: null;

	const showMeta = st != null;
	const startedLabel =
		showMeta && st.startedAt != null && st.startedAt !== ''
			? moment(st.startedAt).format('DD.MM.YYYY HH:mm')
			: showMeta
				? '—'
				: null;
	const who = showMeta
		? (st.user != null && st.user.name != null && st.user.name !== '' ? st.user.name : null) || st.userId || '—'
		: null;

	const combinedEmptyMessage =
		!spellCheckLoading &&
		st == null &&
		responseRaw == null &&
		'Сведения о последней сохранённой проверке орфографии в системе отсутствуют. Запустите проверку орфографии кнопкой в боковой панели.';

	const hintNoResponseYet =
		!spellCheckLoading &&
		st != null &&
		responseRaw == null &&
		'Запустите проверку орфографии кнопкой в боковой панели.';

	return (
		<div style={{ padding: '16px 0', ...wrapLongText }}>
			{spellCheckLoading ? <p>Проверка орфографии…</p> : null}
			{combinedEmptyMessage ? <p style={{ color: '#888', marginBottom: 0 }}>{combinedEmptyMessage}</p> : null}

			{!spellCheckLoading && showMeta ? (
				<dl
					style={{
						margin: '0 0 16px 0',
						display: 'grid',
						gridTemplateColumns: '140px minmax(0, 1fr)',
						gap: '8px 12px',
						alignItems: 'start',
					}}
				>
					<dt style={{ color: '#666' }}>Когда</dt>
					<dd style={{ margin: 0, ...wrapLongText }}>{startedLabel}</dd>
					<dt style={{ color: '#666' }}>Кто запускал</dt>
					<dd style={{ margin: 0, ...wrapLongText }}>{who}</dd>
					<dt style={{ color: '#666' }}>Итог</dt>
					<dd style={{ margin: 0 }}>{st.passed ? 'Без замечаний' : 'Есть замечания'}</dd>
				</dl>
			) : null}

			{!spellCheckLoading && showMeta && st.error != null && st.error !== '' ? (
				<p style={{ color: '#c62828', marginTop: 0, marginBottom: 12, ...wrapLongText }}>
					Ошибка сервиса: {st.error}
				</p>
			) : null}

			{responseRaw != null && !spellCheckLoading ? (
				<div style={{ minWidth: 0, maxWidth: '100%' }}>
					<Subheader style={{ paddingLeft: 0 }}>Ответ сервиса</Subheader>
					<div
						style={wrapLongText}
						dangerouslySetInnerHTML={{
							__html: formatSpellCheckResult(responseRaw),
						}}
					/>
				</div>
			) : !spellCheckLoading && hintNoResponseYet ? (
				<p style={{ color: '#888', marginTop: 0, marginBottom: 0 }}>{hintNoResponseYet}</p>
			) : null}

			{factChecking != null && !spellCheckLoading ? (
				<button
					type="button"
					style={factCheckingLinkStyle}
					onClick={() => setFactCheckingOpen(true)}
				>
					Результаты фактчекинга
				</button>
			) : null}

			{factChecking != null ? (
				<ArticleFactCheckingDialog
					open={factCheckingOpen}
					onRequestClose={() => setFactCheckingOpen(false)}
					content={factChecking}
				/>
			) : null}
		</div>
	);
}



// WEBPACK FOOTER //
// src/components/articles/ArticleSpellCheckStatusSection.js